// extracted by mini-css-extract-plugin
export default {"img":"Yjsin1BJnSTV8zy4c8dN","responsive":"Nqpfe5YWHWmspjZXJT5Q"};